class EcoCutGiftWrap extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  if(location.hash==='#cadeauverpakking')this.querySelector('details').open=true;
  this.querySelector('[data-wrap-form]')?.addEventListener('submit',event=>{event.preventDefault();this.save(false);});
  this.querySelector('[data-wrap-remove]')?.addEventListener('click',()=>this.save(true));
 }
 async request(path,body){
  const response=await fetch(this.dataset.root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',...(body?{body:JSON.stringify(body)}:{})});
  const data=await response.json();if(!response.ok)throw new Error(data.description||this.dataset.error);return data;
 }
 async save(remove){
  if(this.busy)return;this.busy=true;
  const buttons=[...this.querySelectorAll('button')],status=this.querySelector('[data-wrap-status]');
  buttons.forEach(b=>b.disabled=true);status.textContent=this.dataset.saving;
  try{
   let cart=await this.request('cart.js'),id=Number(this.dataset.variant);
   const existing=cart.items.filter(item=>item.variant_id===id);
   if(remove){
    if(existing.length){const updates={};existing.forEach(item=>updates[item.key]=0);await this.request('cart/update.js',{updates});}
   }else{
    if(!cart.items.some(item=>item.variant_id!==id&&item.quantity>0))throw new Error(this.dataset.noProduct);
    const message=this.querySelector('textarea').value.trim().slice(0,240);
    const properties={'_ecocut_gift_wrap':'order','Tekst op kaartje':message||'Kaartje zonder tekst'};
    if(existing.length>1){
     const updates={};existing.slice(1).forEach(item=>updates[item.key]=0);cart=await this.request('cart/update.js',{updates});
    }
    const first=cart.items.find(item=>item.variant_id===id);
    if(first)await this.request('cart/change.js',{id:first.key,quantity:1,properties});
    else await this.request('cart/add.js',{items:[{id,quantity:1,properties}]});
   }
   window.location.reload();
  }catch(error){status.textContent=error.message||this.dataset.error;buttons.forEach(b=>b.disabled=false);this.busy=false;}
 }
}
if(!customElements.get('ec-gift-wrap'))customElements.define('ec-gift-wrap',EcoCutGiftWrap);
document.addEventListener('click',event=>{const link=event.target.closest?.('.ec-wrap-product-link');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();event.stopImmediatePropagation();window.location.assign(link.href);},true);
